import {LitElement, html} from 'lit';
import letterFormStyles from "./_letter-form.scss";
import {convert} from "html-to-text";

export class LetterForm extends LitElement {
	static properties = {
		name: {},
		adminName: {},
		studentPercent: {},
		schoolArea: {},
		accessPercent: {},
	}

	static styles = [letterFormStyles];

	constructor() {
		super();

		this.schoolArea = "";
		this.adminName = "";
		this.studentPercent = "";
		this.accessPercent = "";
		this.name = "";
		this.letterExport = "Dear Principal Johnson,\n" +
			"\n" +
			"I am writing to discuss the importance of expanding access to computer science (CS) education in Springfield Elementary. I would like to see more CS classes offered and taught by well-prepared teachers in classrooms full of students representative of our student body, including girls, Latinx students, Black students, and low-income students.\n" +
			"Computer science is a critical subject; from computational thinking, creativity, and problem-solving, the skills learned will prepare our students to engage fully in society and thrive in the evolving job market. We must take bold steps to ensure that all of our students are sufficiently prepared for college, careers, and community participation. \n" +
			"Shockingly, the majority of California’s students still do not have access to CS education. Students of color, girls, and students from low-income families are less likely to have access to and participation in CS classes. Here in Springfield Elementary, only 12% of students are enrolled in computer science, and only 1.7% have access.\n" +
			"Our students deserve better. We need to take bold action to ensure they have access to a rigorous computer science education that prepares them for their future—regardless of race, gender, geography, or economic background.\n" +
			"\n" +
			"\n\t" + "- Not sure where to begin? Our CS Equity Guide has everything you need to know to get started, from integrating CS into existing classes to adding CS as a new subject in your school or district." +
			"\n\t" + "- Need to know how to prepare teachers to teach CS in K12? Mark the Summer of CS on your professional development calendar. Each year in June, teachers of all grades come together to learn about equity-minded curriculums currently used across California through a series of workshops." +
			"\n\t" + "- Wonder how CS fits into the curriculum? You can use the CS Strategic Implementation Plan as a roadmap." +
			"\n\t" + "- Not sure how to bring parents and students on board? Host a Family Code Night to give parents/families/caretakers and potential CS students hands-on experience." +
			"\n" +
			"\n" +
			"\n" +
			"For more information about bringing CS to your school, and to see how our community compares to others in the state, please visit CSforCA.org.\n" +
			"\n" +
			"Sincerely, \n" +
			"Sally Fields";
	}

	handleInputChange(event) {

		switch(event.target.id) {
			case "schoolArea": {
				this.schoolArea = event.target.value;
			}
			break;
			case "schoolAdmin": {
				this.adminName = event.target.value;
			}
			break;
			case "name": {
				this.name = event.target.value;
			}
			break;
			case "accessPercent": {
				if(!event.target.value.endsWith("%")) {
					this.accessPercent = event.target.value + "%";
				} else {
					this.accessPercent = event.target.value;
				}
			}
			break;
			case "studentPercent": {
				if(!event.target.value.endsWith("%")) {
					this.studentPercent = event.target.value + "%";
				} else {
					this.studentPercent = event.target.value;
				}
			}
			break;
		}
	}

	copyHandler() {
		const letterTemplate = this.querySelector(".letter-template");
		console.log(letterTemplate);
		selectText(letterTemplate);
		document.execCommand("copy");
		console.log("we got here");
	}

	downloadHandler() {
		const letterTemplate = this.querySelector(".letter-template");

		const text = convert(letterTemplate.outerHTML, {
			wordwrap: 140
		});
		console.debug(text);

		download("advocacy-letter.txt", text);

	}


	willUpdate(_changedProperties) {

	}

	createRenderRoot() {
		return this;
	}

	render() {
		const letter = html`
			<div class="letter-template">
			<p>Dear <strong>${this.adminName}</strong>,</p>
			<br/>
			<p>
				I am writing to discuss the importance of expanding access to computer science (CS) education in <strong>${this.schoolArea}</strong>. I would like to see more CS classes offered and taught by well-prepared teachers in classrooms full of students representative of our student body, including girls, Latinx students, Black students, and low-income students.
			</p>
			<p>
				Computer science is a critical subject; from computational thinking, creativity, and problem-solving, the skills learned will prepare our students to engage fully in society and thrive in the evolving job market. We must take bold steps to ensure that all of our students are sufficiently prepared for college, careers, and community participation.
			</p>
			<p>
				Shockingly, the majority of California’s students still do not have access to CS education. Students of color, girls, and students from low-income families are less likely to have access to and participation in CS classes. Here in <strong>${this.schoolArea}</strong>, only <strong>${this.studentPercent}</strong> of students are enrolled in computer science, and only <strong>${this.accessPercent}</strong> have access.
			</p>
			<p>
				Our students deserve better. We need to take bold action to ensure they have access to a rigorous computer science education that prepares them for their future—regardless of race, gender, geography, or economic background.
			</p>
			<br />
			<ul>
				<li><strong class="callout">Not sure where to begin?</strong> Our CS Equity Guide has everything you need to know to get started, from integrating CS into existing classes to adding CS as a new subject in your school or district.</li>
				<li><strong class="callout">Need to know how to prepare teachers to teach CS in K12?</strong> Mark the Summer of CS on your professional development calendar. Each year in June, teachers of all grades come together to learn about equity-minded curriculums currently used across California through a series of workshops.</li>
				<li><strong class="callout">Wondering how CS fits into the curriculum?</strong> You can use the CS Strategic Implementation Plan as a roadmap.</li>
				<li><strong class="callout">Not sure how to bring parents and students on board?</strong> Host a Family Code Night to give parents/families/caretakers and potential CS students hands-on experience.</li>
			</ul>
			<br />
			<p>For more information about bringing CS to your school, and to see how our community compares to others in the state, please visit <a href="https://csforca.org/">CSforCA.org</a></p>
			<br />
			<br />
			<div>Sincerely,</div>
			<div><strong>${this.name}</strong></div>
			</div>
		`;

		return html`
			<div class="letter-inputs">
				<label for="schoolAdmin">
				Administrator/Principal title
				</label>
				<input id="schoolAdmin" @input="${this.handleInputChange}">
				<label for="schoolArea">
					Your school, district, or county
				</label>
				<input id="schoolArea" @input="${this.handleInputChange}">

				<label for="studentPercent">% of students enrolled in Computer Science</label>
				<input id="studentPercent" @input="${this.handleInputChange}">
				<label for="accessPercent">% of students who have access</label>
				<input id="accessPercent" @input="${this.handleInputChange}">
				<label for="name">Your Name</label>
				<input id="name" @input="${this.handleInputChange}">
			</div>
			${letter}

			<div class="buttons">
				<button class="btn btn-border-solid" @click="${this.copyHandler}">
					Copy This Template
				</button>
				<button class="btn btn-border-solid" @click="${this.downloadHandler}">
					Download
				</button>
			</div>
		`
	}
}

function selectText(node) {
	if (document.body.createTextRange) {
		const range = document.body.createTextRange();
		range.moveToElementText(node);
		range.select();
	} else if (window.getSelection) {
		const selection = window.getSelection();
		const range = document.createRange();
		range.selectNodeContents(node);
		selection.removeAllRanges();
		selection.addRange(range);
	} else {
		console.warn("Could not select text in node: Unsupported browser.");
	}
}

function download(filename, text) {
	var element = document.createElement('a');
	element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
	element.setAttribute('download', filename);

	element.style.display = 'none';
	document.body.appendChild(element);

	element.click();

	document.body.removeChild(element);
}
